export default __webpack_public_path__ + "static/media/pause.d9359654.svg";